import { render } from "./PrivacyPopup.vue?vue&type=template&id=23b56756&scoped=true&ts=true"
import script from "./PrivacyPopup.vue?vue&type=script&lang=ts"
export * from "./PrivacyPopup.vue?vue&type=script&lang=ts"

import "./PrivacyPopup.vue?vue&type=style&index=0&id=23b56756&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b56756"]])

export default __exports__